export const pluralize = (rootWord: string, count: number) => {
  if (count > 1) return `${rootWord}s`
  return rootWord
}
